import { render, staticRenderFns } from "./DesmatamentoHansen.vue?vue&type=template&id=0e400b0f&lang=pug"
import script from "./DesmatamentoHansen.vue?vue&type=script&lang=js"
export * from "./DesmatamentoHansen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports